module.exports = __webpack_public_path__ + "img/52.737cab0c.png";